export class WebinarConnectionDataDTO {
  signature: string;
  apiKey: string;
  key: string;
}
